export default "__VITE_ASSET__a298b89d__"